import styled, { css, DefaultTheme, keyframes } from 'styled-components';

const pulse = ({ theme }: { theme: DefaultTheme }) => keyframes`
  0% {
    background-position: -${theme.sz.md} 0
  }
  100% {
    background-position: ${theme.sz.md} 0
  }
`;

export const LoadingSkeleton = styled.div<{ $dark?: boolean }>(({ theme, $dark }) => {
  return css`
    min-width: ${theme.sz.s54};
    min-height: ${theme.sz.s64};
    width: 100%;
    height: 100%;
    border-radius: ${theme.bo.medium};
    animation: ${pulse} infinite 2.5s linear;
    animation-fill-mode: forwards;
    background: ${`linear-gradient(to right, ${
      $dark ? theme.co.secondary20 : theme.co.neutral98
    } 8%, ${$dark ? theme.co.secondary40 : theme.co.neutral95} 48%, ${
      $dark ? theme.co.secondary20 : theme.co.neutral98
    } 63%)`};
    background-size: ${theme.sz.md} ${theme.sz.s40};
    position: relative;
  `;
});
